import { MessagingChannel } from '~hooks/useMessaging/models';
import useMarkChannelRead from '~hooks/useMessaging/useMarkChannelRead';
import useUnreadDivider from '~hooks/useMessaging/useUnreadDivider';
import useMessagingMessagesInfiniteQuery from '~queries/useMessagingMessagesInfiniteQuery';
import { Nullable } from '~types/Nullable';

export default function useTranscriptReadState({
  channel,
  channelId,
  isRefreshingChannel,
  transcript,
  viewerUserId,
}: {
  channel: Nullable<MessagingChannel>;
  channelId: Nullable<string>;
  isRefreshingChannel: boolean;
  transcript: ReturnType<typeof useMessagingMessagesInfiniteQuery>;
  viewerUserId: Nullable<string>;
}) {
  const isRefreshing = isRefreshingChannel || transcript.isRefreshing;

  useMarkChannelRead({ channel, isRefreshing, messages: transcript.messages });

  return useUnreadDivider({
    channel,
    channelId,
    hasLoadFailed: transcript.hasLoadFailed,
    hasOlder: transcript.hasOlder,
    hasOlderLoadFailed: transcript.hasOlderLoadFailed,
    isLoading: transcript.isLoading,
    isLoadingOlder: transcript.isLoadingOlder,
    isRefreshing,
    messages: transcript.messages,
    onLoadOlder: transcript.fetchOlder,
    viewerUserId,
  });
}
